import { Card, CardActions, CardContent, CardHeader, Collapse, IconButton } from "@mui/material";
import { Filter, IFilterSets } from "../Filter/Filter";
import { useState } from "react";
import styled from "@emotion/styled";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './styles.css';
import { Sort, SortOrder } from "../Sort/Sort";

export interface ISettings {
    sortOrder: SortOrder;
    filterSets: IFilterSets;
}

export const Settings2 = () => {
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const ExpandMore = styled((props: any) => {
        const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            marginTop: 0,
    }));

    return (
        <Card sx={{ width: "100%", maxWidth: "400pt", margin: "0 auto", marginBottom: "5px" }}>
            <CardActions disableSpacing>
            <span className='expandTitle'>{ '⚙️ Настройки' }</span>
                <ExpandMore
                    expand={ expanded }
                    onClick={ handleExpandClick }
                    aria-expanded={ expanded }
                    aria-label="Подробнее"
                >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <Filter />
                    <Sort />
                </CardContent>
            </Collapse>
        </Card>
    );
}